// extracted by mini-css-extract-plugin
var _1 = "FormModalContainer-moduleconfirmation__TE9ZG";
var _2 = "FormModalContainer-modulemodal__c29CF Modal-moduleModal__c1dw1";
export { _1 as "confirmation", _2 as "modal" }
